import PassengerAddress from "../../types/passenger-address";

const getAddressLabel = (address: PassengerAddress) => {
  const displayName = {
    country: address.country ?? "",
    town: address.town ?? "",
    street: address.street ?? "",
    houseNumber: address.houseNumber ?? "",
    apartmentNumber: address.apartmentNumber ?? "",
    zipCode: address.zipCode ?? "",
  };

  return `${displayName.street} ${displayName.houseNumber}${
    displayName.apartmentNumber && `/${displayName.apartmentNumber}`
  } ${displayName.town}, ${displayName.zipCode}`;
};

const passengerAddressHelper = {
  getAddressLabel,
};

export default passengerAddressHelper;
